<template>
  <div>
    <div class="yellow-car-sell align" v-if="sell&&sell>0">
      <img class="shopping-car" src="../static/images/shopping-car.png" alt="">
      <span class="number-font">¥{{$retainWan(sell)}}</span>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      sell: {
        type: [Number, String],
      },
    },
  }
</script>

<style lang="less" scoped>
  .yellow-car-sell {
    position: absolute;
    right: 0;
    top: 0;
    background:rgba(255,153,0,1);
    border-radius:0 0 0 .16rem;
    width: 2.3rem;
    height: 0.6rem;
    padding-left: 0.1rem;
    color: #fff;
    font-size: .28rem;
    font-weight: bold;
    .shopping-car {
      width: 0.3rem;
      height: 0.3rem;
      margin-right: 0.1rem;
    }
    span {
      margin-top: 0.05rem;
    }
  }
</style>